import React from "react";
import { AnalysisData } from "@/services/statistical-analysis-service";
import { BaseAlert } from "../base/BaseAlert";
import { usePriceAlertState } from "./usePriceAlertState";

export interface PriceAnalysisAlertProps {
  analysis?: AnalysisData;
  loading?: boolean;
  hasRequiredData?: boolean;
  neighborhood?: string | null;
  sizeM2?: string;
  capacity?: string;
  monthlyPrice?: string;
  sampleSize?: number;
  minSampleSize?: number;
  className?: string;
  "data-testid"?: string;
}

export const PriceAnalysisAlert: React.FC<PriceAnalysisAlertProps> = ({
  analysis,
  loading = false,
  hasRequiredData = true,
  neighborhood,
  sizeM2,
  capacity,
  monthlyPrice,
  sampleSize,
  minSampleSize,
  className,
  "data-testid": testId = "price-analysis-alert",
}) => {
  const alertState = usePriceAlertState({
    analysis,
    loading,
    hasRequiredData,
    neighborhood,
    sizeM2,
    capacity,
    monthlyPrice,
    sampleSize,
    minSampleSize,
  });

  if (!alertState) {
    return null;
  }

  return (
    <div className="mt-2">
      <BaseAlert
        {...alertState}
        size="compact"
        className={className}
        data-testid={testId}
      />
    </div>
  );
};

PriceAnalysisAlert.displayName = "PriceAnalysisAlert";
